import axios from "axios";
import CoreService from "./core.service";

axios.defaults.withCredentials = true;
 
// Get all ads (for admin management)
export const getAds = (type = "") => {
  const params = type ? `?type=${type}` : "";
  return axios.get(`${CoreService.getPrivateURL()}ads${params}`, { withCredentials: true });
};

// Get active ads for display
export const getActiveAds = () => {
  return axios.get(`${CoreService.getPrivateURL()}ads/active`, { withCredentials: true });
};

// Get single ad
export const getAd = (id) => {
  return axios.get(`${CoreService.getPrivateURL()}ads/${id}`, { withCredentials: true });
};

// Get ad statistics
export const getAdStats = (id) => {
  return axios.get(`${CoreService.getPrivateURL()}ads/${id}/stats`, { withCredentials: true });
};

// Create new ad
export const createAd = (data) => {
  return axios.post(`${CoreService.getPrivateURL()}ads`, data, { withCredentials: true });
};

// Update ad
export const updateAd = (id, data) => {
  return axios.put(`${CoreService.getPrivateURL()}ads/${id}`, data, { withCredentials: true });
};

// Delete ad
export const deleteAd = (id) => {
  return axios.delete(`${CoreService.getPrivateURL()}ads/${id}`, { withCredentials: true });
};

// Dismiss ad (user closes it)
export const dismissAd = (id) => {
  return axios.post(`${CoreService.getPrivateURL()}ads/${id}/dismiss`, {}, { withCredentials: true });
};

// Track ad click
export const clickAd = (id) => {
  return axios.post(`${CoreService.getPrivateURL()}ads/${id}/click`, {}, { withCredentials: true });
};

// Upload ad image
export const uploadAdImage = (formData) => {
  return axios.post(`${CoreService.getPrivateURL()}ads/images`, formData, {
    withCredentials: true,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const AdsService = {
  getAds,
  getActiveAds,
  getAd,
  getAdStats,
  createAd,
  updateAd,
  deleteAd,
  dismissAd,
  clickAd,
  uploadAdImage,
};

export default AdsService;

